<div>tttttt</div>
<template>
<div>
  <div style="overflow:hidden;margin-top: 0.47rem;">
      <div class="blue"></div>
      <p class="title">品质课程</p>
    </div>
  <div class="className">    
    <div
      class="card"
      v-for="(item,index) in classList"
      :key="index"
      @click="getClassId(item.classId,item.shortName)"
    >
      <img :src="item.url" alt />
      <p v-html="item.className"></p>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      classList: [
        {
          url: require("../assets/images/01.png"),
          className: "全日制就业班",
          classId: 1,
          shortName: "csjy.html",
          // type: 1
        },
        //{
        //  url: require("../assets/images/02.png"),
        //  className: "测试提速班",
        //  classId: 2,
        //  shortName: "csjy.html",
          // type: 1
        //},
        {
          url: require("../assets/images/03.png"),
          className: "测试定制班",
          classId: 3,
          shortName: "csjy.html",
          // type: 1
        },
        {
          url: require("../assets/images/04.png"),
          className: "测试开发班",
          classId: 4,
          shortName: "cskf.html"
        },
        //{
        //  url: require("../assets/images/05.png"),
        //  className: "周末精品班",
        //  classId: 5,
        //  shortName: "zhoumo.html"
        //},
        //{
        //  url: require("../assets/images/06.png"),
        //  className: "Python</br>测试开发",
        //  classId: 6,
        //  shortName: "python.html"
        //},
        {
          url: require("../assets/images/09.png"),
          className: "车载测试",
          classId: 7,
          shortName: "mcar.html"
        },
        {
          url: require("../assets/images/07.png"),
          className: "ISTQB认证",
          classId: 7,
          shortName: "renzheng.html"
        },
        {
          url: require("../assets/images/ruankao.png"),
          className: "软考",
          classId: 7,
          shortName: "ruankao-m.html"
        },

        {
          url: require("../assets/images/08.png"),
          className: "自学资料",
          classId: 8,
          shortName: "selflearning.html"
        }
      ]
    };
  },
  methods: {
    getClassId(id, shortName) {
      this.$router.push({
        path: `/${shortName}`,
        query: {
          type: 1
        }
      });
    }
  }
};
</script>

<style>
.className {
  padding-left: 36px;
  padding-right: 36px;
  height: 480px;
  /* clear: both; */
}

.card {
  width: 25%;
  height: 2.4rem;
  float: left;
  text-align: center;
  margin-top: 0.7rem;
  /* margin-left: 52px; */
}
.card img {
  width: 96px;
  height: 96px;
}
.card p {
  font-size: 26px;
  color: #282828;
  margin-top: 24px;
}


.blue {
  width: 6px;
  height: 30px;
  background: #64b3f1;
  float: left;
  margin-top: 5px;
  margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Class.vue